import React from 'react';
export function Footer() {
  return <footer className="bg-brand-darker py-14 px-4 border-t border-brand-primary/25 text-center" data-id="element-157" data-mp="32wd2cf6gdjt0">
      <div className="max-w-4xl mx-auto" data-id="element-158" data-mp="3ggtxgg3gzf46">
        <div className="mb-8" data-id="element-159" data-mp="32o4bgbnxya72">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-brand-cream/10 text-brand-cream text-sm font-bold tracking-wide border border-brand-primary/30 mb-4" data-id="element-160" data-mp="32ovukn0cqfgg">
            🌿 MAMÁ SIN CAOS®
          </span>
          <p className="text-brand-cream-light font-serif text-xl mb-2" data-id="element-161" data-mp="3ucxoy1myl9cy">
            Guiado por asesora certificada de lactancia — para mamás primerizas
            en Argentina.
          </p>
          <p className="text-brand-cream/65 italic" data-id="element-162" data-mp="3le2katzkc7br">
            Porque criar no tiene que doler.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-brand-primary/80 mb-12 text-sm" data-id="element-163" data-mp="29z6tyark0hfd">
          <a href="mailto:soporte.mamasinkos@gmail.com" className="hover:text-brand-accent transition-colors" data-id="element-164" data-mp="2ey9zrxfcyroe">
            📧 soporte.mamasinkos@gmail.com
          </a>
          <a href="https://www.instagram.com/mamasiincaos?igsh=dnVnOHZ3M2VhY2hk&utm_source=qr" target="_blank" rel="noopener noreferrer" className="hover:text-brand-accent transition-colors" data-id="element-165" data-mp="3gah13thslj5u">
            📲 @mamasincaos
          </a>
          <a href="https://lactancia.mamasincaos.store/" target="_blank" rel="noopener noreferrer" className="hover:text-brand-accent transition-colors" data-id="element-166" data-mp="830jvkr3s91j">
            🌐 lactancia.mamasincaos.store
          </a>
        </div>

        <div className="text-brand-primary/40 text-xs space-y-4" data-id="element-167" data-mp="huwgsshgdt46">
          <p data-id="element-168" data-mp="cv1s8vl5hfma">
            © SR Digitales — Mamá sin Caos® 2026 — Todos los derechos
            reservados.
          </p>
          <p className="font-serif text-brand-primary/60 text-base italic" data-id="element-169" data-mp="qtro67w8h992">
            🌿 "La próxima toma puede ser diferente."
          </p>
        </div>
      </div>
    </footer>;
}